var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportBiking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.21 6.325 5.232 9.941v.001a.5.5 0 0 1-.884.467v-.001l-2.642-4.99-4.024 5.068A.5.5 0 0 1 11.5 17H5a.5.5 0 0 1-.376-.83l3.829-4.376.753.659L6.102 16h5.157l4.157-5.236-2.091-3.974.885-.465z",
    fill: "#323848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9H18v1h-2.5V9zM11.5 6.5A.5.5 0 0 1 12 6h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zM8.5 11.5h-6a.5.5 0 0 1 0-1h6v1zM5.5 9a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5zM9.676 16.23c0-2.358-1.942-4.27-4.338-4.27S1 13.871 1 16.231c0 2.359 1.942 4.271 4.338 4.271s4.338-1.911 4.338-4.272zm-7.437 0c0-1.684 1.388-3.05 3.099-3.05 1.711 0 3.099 1.366 3.099 3.051s-1.388 3.051-3.099 3.051c-1.711 0-3.099-1.366-3.099-3.052z",
    fill: "#323848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.485a.3.3 0 0 1 .434-.268l1.4.7a.3.3 0 0 1 .166.268V20.7a.3.3 0 0 1-.3.3h-1.4a.3.3 0 0 1-.3-.3v-9.215zM20 12.313a.194.194 0 0 0-.14-.188 4.405 4.405 0 0 0-1.198-.165c-2.396 0-4.338 1.911-4.338 4.271 0 2.359 1.942 4.271 4.338 4.271.416 0 .818-.057 1.198-.165a.194.194 0 0 0 .14-.188v-.85c0-.146-.153-.244-.292-.195-.327.115-.679.178-1.046.178-1.711 0-3.099-1.366-3.099-3.052 0-1.684 1.388-3.05 3.099-3.05.367 0 .72.063 1.046.178.139.05.292-.049.292-.195v-.85zM17.179 8.135a.5.5 0 0 1 .481-.635h3.18a.5.5 0 0 1 .481.635l-.843 3a.5.5 0 0 1-.482.365h-1.492a.5.5 0 0 1-.482-.365l-.843-3z",
    fill: "#323848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.686 8.818 4.248 7.434a.5.5 0 0 1-.868.496L6.818 9.314l.868-.496z",
    fill: "#323848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportBiking);
export default __webpack_public_path__ + "static/media/transport-biking.ed65c982531992b567bf2b117a7383fd.svg";
export { ForwardRef as ReactComponent };